import * as Api from '@ViewModels';
import { useState } from 'react';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { getIndustries } from '../../../../models/utils/businessUtils';
import { getIndustryName } from '../../../../models/utils/stringUtils';

/** The industry the curated prompts are shown for: the account's own until someone picks another. */
export const usePromptIndustry = () => {
	const userSession = useUserSession();
	const account = userSession?.account;
	const [selectedIndustry, setSelectedIndustry] = useState<Api.Industry | null>(null);

	const options = getIndustries({
		accountId: account?.id,
		brokerDealer: account?.additionalInfo?.brokerDealer,
	});
	// Select renders the raw value in the trigger unless it is given the label for it, which would show Others as
	// its underlying '_Others_'.
	const items = options.map(option => ({ label: getIndustryName(option), value: option }));
	const accountIndustry = account?.additionalInfo?.industry;
	// Falls back to the first option rather than a fixed industry: broker-dealer restrictions can drop Insurance from
	// the list entirely, which would leave the select displaying a value it has no item for.
	const industry =
		selectedIndustry ?? (accountIndustry && options.includes(accountIndustry) ? accountIndustry : options[0]);

	return { industry, industryName: industry ? getIndustryName(industry) : '', items, setIndustry: setSelectedIndustry };
};
